export default __webpack_public_path__ + "static/media/sweaty-politics.f31f1bd5.jpg";